import {handleBody, handleExceptions, GET} from '../utils/api';

export const getTravelIdeas = () => {
  const endpoint = 'ideas';

  return GET(endpoint).then((response) => {
    if (response.status >= 400) {
      return handleExceptions(response);
    }

    return handleBody(response);
  });
};
